import { useState } from 'react';
import { BuildingFiltersKeys } from '@/components/building-filters/BuildingFilters';
import BuildingFiltersMoreButton from '@/components/building-filters/BuildingFiltersMoreButton';
import BuildingFiltersMoreMenu from '@/components/building-filters/BuildingFiltersMoreMenu';

// Filters that are only meaningful in the consumption tab and must be cleared when switching to demand.
export const CONSUMPTION_ONLY_FILTERS = [BuildingFiltersKeys.hasConsumptionData];

export const getConsumptionOnlyFiltersReset = () =>
  Object.fromEntries(CONSUMPTION_ONLY_FILTERS.map((k) => [k, null])) as Record<
    (typeof CONSUMPTION_ONLY_FILTERS)[number],
    null
  >;

export function getAnalysisHiddenFilters(isConsumptionView: boolean): BuildingFiltersKeys[] {
  return isConsumptionView
    ? [BuildingFiltersKeys.activeStateFilter]
    : [BuildingFiltersKeys.activeStateFilter, ...CONSUMPTION_ONLY_FILTERS];
}

// Filters only meaningful within Analysis's consumption tab — hidden in the
// Data Collection buildings/economic-units toolbars, which have no such tab.
const DATA_COLLECTION_HIDDEN_FILTERS = CONSUMPTION_ONLY_FILTERS;

export const DATA_COLLECTION_BUILDINGS_HIDDEN_FILTERS = [
  BuildingFiltersKeys.economicUnitResponsibleUserIds,
  ...DATA_COLLECTION_HIDDEN_FILTERS,
];

export const DATA_COLLECTION_ECONOMIC_UNITS_HIDDEN_FILTERS = [
  BuildingFiltersKeys.responsibleUserIds,
  ...DATA_COLLECTION_HIDDEN_FILTERS,
];

type Props = {
  isLoading?: boolean;
  isConsumptionView?: boolean;
  height?: number;
};

export function BuildingFiltersMenuControl({ isLoading, isConsumptionView = false, height }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const hiddenFilters = getAnalysisHiddenFilters(isConsumptionView);

  return (
    <>
      <BuildingFiltersMoreButton handleOpen={handleOpen} isOpen={!!anchorEl} height={height} />
      <BuildingFiltersMoreMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        isLoading={isLoading}
        hiddenFilters={hiddenFilters}
      />
    </>
  );
}
